import {
  fab,
  faFacebook,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faSquareInstagram,
  faTiktok,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCopy,
  faCopyright,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsletterSection";
import FooterQuickLinks from "../component/FooterQuickLinks";
import ChatWithWhatsappBtn from "../component/ChatWithWhatsappBtn";
import { useEffect, useState } from "react";
import { API_FOOTER_QUICK_LINKS } from "../ApiEndPoints";
import AxiosClient from "../client/AxiosClient";

export default function Footer() {
  return (
    <footer className="text-center text-md-start pb-0">
      <div className="container">
        <NewsletterSection />
        <div className="row">
          <div className="col-md-12 col-lg-5 pe-4">
            <div className="mb-2 text-center text-md-start">
              <img
                src="/footer-logo.png"
                alt="logo"
                style={{ maxWidth: "140px", height: "auto" }}
              />
            </div>
            <p>
              <Col1 />
            </p>

            <div className="d-flex justify-content-center justify-content-md-start mb-md-4 mb-lg-0">
              {/* <a
                href="https://twitter.com/IndiaAcademyLaw"
                target="_blank"
                className="social-icons text-decoration-none mx-2 cursor-pointer"
                rel="noreferrer noopener"
                style={{ backgroundColor: "#1DA1F2" }}
              >
                <FontAwesomeIcon icon={faTwitter} className="" />
              </a> */}

              <a
                href="https://www.linkedin.com/company/indian-academy-of-law-&-management/?viewAsMember=true&original_referer=http%3A%2F%2Fialm.paybevdev.com%2F"
                target="_blank"
                className="social-icons text-decoration-none mx-2 cursor-pointer"
                rel="noreferrer noopener"
                style={{ backgroundColor: "#0077B5" }}
              >
                <FontAwesomeIcon icon={faLinkedinIn} className="" />
              </a>

              <a
                href="https://www.facebook.com/61587367055679/"
                target="_blank"
                className="social-icons text-decoration-none mx-2 cursor-pointer"
                rel="noreferrer noopener"
                style={{ backgroundColor: "#3B5998" }}
              >
                <FontAwesomeIcon icon={faFacebookF} className="" />
              </a>

              <a
                href="https://www.instagram.com/ialm_academy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                className="social-icons text-decoration-none mx-2 cursor-pointer"
                rel="noreferrer noopener"
                style={{
                  background: "#833ab4",
                  backgroundImage: `linear-gradient(to right, #833ab4,#fd1d1d,#fcb045)`,
                }}
              >
                <FontAwesomeIcon icon={faInstagram} className="" />
              </a>

              <a
                href="mailto:registrar@ialm.academy"
                target="_blank"
                className="social-icons text-decoration-none mx-2 cursor-pointer"
                rel="noreferrer noopener"
                style={{ backgroundColor: "#d44638" }}
              >
                <FontAwesomeIcon icon={faEnvelope} className="" />
              </a>
              <a
                href="https://www.youtube.com/@indianacademyoflawandmanag8195"
                target="_blank"
                className="social-icons text-decoration-none mx-2 cursor-pointer"
                rel="noreferrer noopener"
                style={{ backgroundColor: "#FF0000" }}
              >
                <FontAwesomeIcon icon={faYoutube} className="" />
              </a>
            </div>
          </div>
          <div className="col-md-12 col-lg-7">
            <div className="row">
              <div className="col-md-4 col-lg-4 px-3">
                <h5 className="mb-0">Quick Links</h5>
                <div className="list-group non-style mb-4 mb-md-0">
                  {/*  <Link
                    to="/blogs"
                    className="list-group-item list-group-item-action cursor-pointer"
                    aria-current="true"
                  >
                    Blog
                  </Link>

                  <Link
                    to="/page/faqs"
                    className="list-group-item list-group-item-action cursor-pointer"
                  >
                    FAQs
                  </Link>
                  <Link
                    to={"/faculties/"}
                    className="list-group-item list-group-item-action cursor-pointer"
                  >
                    All Faculties
                  </Link>
                  <Link
                    className="list-group-item list-group-item-action cursor-pointer"
                    to={"/page/ialm-institutional-collaborations"}
                  >
                    IALM Instituional Collaborations
                  </Link>
                  <Link
                    to="/faculty-registration"
                    className="list-group-item list-group-item-action cursor-pointer"
                  >
                    Course Developer/Part-time Faculty
                  </Link> */}

                  <FooterQuickLinks col={2} />
                </div>
              </div>

              <div className="col-md-4 col-lg-4 px-3">
                <h5 className="mb-0">Policies & Contact</h5>
                <div className="list-group non-style mb-4 mb-md-0">
                  <FooterQuickLinks col={3} />
                </div>
              </div>

              <div className="col-md-4 col-lg-4 px-3">
                <h5 className="mb-0">Contact us</h5>
                <div className="list-group non-style mb-4 mb-md-0">
                  <FooterQuickLinks col={4} />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 border-op">
            <div className="footer-bottom border-top border-1 p-1 mt-4">
              <p className="text-center mb-0 p-2 strong">
                &copy; {new Date().getFullYear()} IALM. All rights reserved
              </p>
            </div>
          </div>
        </div>
      </div>

      <ChatWithWhatsappBtn />
    </footer>
  );
}

function Col1() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AxiosClient.get(API_FOOTER_QUICK_LINKS, {
      params: { col: 1 },
    })
      .then((response) => {
        let responseData = response.data.data;

        setData(responseData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error while fetchign footer quick links: ", error);
      });
  }, []);

  console.log("data is; ", data);

  return <p>{!loading && data}</p>;
}
